import { RouteItem } from '@eastcoal/router/types/route'

import { AuditSuccessfulPage } from './index'

export const auditSuccessRoute: RouteItem = {
  title: '认证成功',
  path: '/audit/success',
  hideInMenu: true,
  element: <AuditSuccessfulPage />
}
